// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__4gA8G","footerInner":"Footer_footerInner__45L7g","footerBrand":"Footer_footerBrand__JYxSM","footerLinks":"Footer_footerLinks__hiD1k"};